// import {Fragment} from 'react';
import {Row, Col, Form} from 'react-bootstrap';

export const Settings = (props) => {
  return  (
        <Row>
        <Col sm={3}>Width of rigid element [10-200]:&nbsp;</Col>
        <Col sm={2}>
          <Form onKeyPress={(ev)=>{
                    if(ev.key==='Enter') {
                      ev.preventDefault();
                      props.setRigidSize(ev)
                    }
                  }} inline>
          <Form.Control className="w-50" type="text" placeholder="rigidElWidth" size="sm" name="rigidSize" key={props.rigidSize} defaultValue={props.rigidSize} />
          </Form>
        </Col>
        </Row>
        );
}